module.exports = __webpack_public_path__ + "img/C.7a998146.png";